<template>
  <div>
    <div style="text-align: center;" v-if="noData">{{ $t('noData') }}</div>
    <AutoRow :data="[
      {
        text: '用户数',
        value: data.users_count,
        to: { name: 'users.index' },
      }, {
        text: '占位',
        value: data.users_count,
        to: { name: 'users.index' },
      }, {
        text: '占位',
        value: data.users_count,
        to: { name: 'users.index' },
      }
    ]" />

    <AutoChartRow :data="[
      {
        text: '新增趋势折线图',
        options: newUsersTrendLineOptions,
      }, {
        text: '新增趋势柱状图',
        options: newUsersTrendBarOptions,
      }
    ]" />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

const AutoRow = {
  functional: true,
  render(h, context) {
    let { data } = context.props;
    data = _.filter(data, datum => !_.isNil(datum.value))
    if (_.size(data) === 0) {
      return <div></div>
    }

    const span = 24 / _.size(data);
    return (
      <el-row gutter={15}>
        {
          _.map(data, datum => {
            return (
              <el-col span={span}>
                <el-card>
                  <div slot="header">{datum.text}</div>
                  <div class="statistics">
                    <bean-link keepNode can={datum.can} to={datum.to}>{ datum.value }</bean-link>
                  </div>
                </el-card>
              </el-col>
            )
          })
        }
      </el-row>
    )
  }
};

const AutoChartRow = {
  functional: true,
  render(h, context) {
    let { data } = context.props;
    data = _.filter(data, datum => !_.isNil(datum.options))
    if (_.size(data) === 0) {
      return <div></div>
    }

    const span = 24 / _.size(data);
    return (
      <el-row gutter={15}>
        {
          _.map(data, datum => {
            return (
              <el-col span={span}>
                <el-card>
                  <div slot="header">{datum.text}</div>
                  <div>
                    <ECharts options={datum.options} style="width:100%" />
                  </div>
                </el-card>
              </el-col>
            )
          })
        }
      </el-row>
    )
  }
};

@Component({
  components: {
    ECharts,
    AutoRow,
    AutoChartRow
  }
})
export default class ApplicationHome extends Vue {
  data = {
  }

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/application')
  }

  get noData() {
    return _.isEmpty(_.filter(_.values(this.data)))
  }

  get newUsersTrendLineOptions() {
    const data = _.filter([{
      legend: '新用户数',
      value: this.data.new_users_trend
    }, {
      legend: '新管理员数',
      value: this.data.new_admin_roles_users_trend
    }], element => !_.isNil(element.value))
    if (_.size(data) === 0) {
      return null
    }

    const legendData = _.map(data, 'legend')

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(data[0].value)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map(
        _.map(data, 'value'),
        (element, index) => {
          return {
            name: legendData[index],
            type: 'line',
            data: Object.values(element)
          }
        }
      )
    })
  }

  get newUsersTrendBarOptions() {
    const data = _.filter([{
      legend: '新用户数',
      value: this.data.new_users_trend
    }, {
      legend: '新管理员数',
      value: this.data.new_admin_roles_users_trend
    }], element => !_.isNil(element.value))
    if (_.size(data) === 0) {
      return null
    }

    const legendData = _.map(data, 'legend')

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(data[0].value)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map(
        _.map(data, 'value'),
        (element, index) => {
          return {
            name: legendData[index],
            type: 'bar',
            data: Object.values(element)
          }
        }
      )
    })
  }
}
</script>
